export const TermsOfUseConstant = 'Notice to End User';
